var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup119(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.843,
    height: 35.088,
    viewBox: "0 0 32.843 35.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(1007.009 -1669.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M-979.519,1698.673V1679.1l-1.63.62c0,2.82-.01,3.547,0,4.947v17.53c0,.859-.22,1.079-1.07,1.079h-22.08c-.84,0-1.08-.24-1.08-1.079v-19.477a.883.883,0,0,1,.14-.03h3.78a2.449,2.449,0,0,0,2.56-2.57c.01-1.15,0-2.3,0-3.44v-.43c.17,0,.29-.01.42-.01q5.865-.015,11.75-.01c.2-.4.33-.66.34-.67-.02-.03-.03-.06-.05-.09-.14-.29-.29-.58-.44-.87q-6.315,0-12.62-.01a1.27,1.27,0,0,0-.97.41q-3.06,3.075-6.13,6.12a1.314,1.314,0,0,0-.41,1c.01,7.93.01,12.227.01,20.156a3.469,3.469,0,0,0,.07.79,2.436,2.436,0,0,0,2.48,1.861h18.95c1.19,0,2.37.01,3.56,0a2.392,2.392,0,0,0,2.4-2.17C-979.5,1701.393-979.509,1700.032-979.519,1698.673Zm-21.06-21.187a1.176,1.176,0,0,1,.03.21c0,.83.01,1.66,0,2.49a.758.758,0,0,1-.83.86c-.91.01-1.81,0-2.75,0C-1002.919,1679.836-1001.759,1678.666-1000.579,1677.486Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M-991.681,1691.6l4.455-4.459c-.371,0-.714,0-1.058,0-.584-.005-.969-.343-.958-.838a.855.855,0,0,1,.951-.81q1.494-.008,2.988,0a.846.846,0,0,1,.939.968q0,1.494,0,2.988a.84.84,0,0,1-.81.941.85.85,0,0,1-.824-.9c-.014-.36,0-.721,0-1.169-.162.151-.261.239-.355.332l-4.547,4.546c-.548.548-.93.548-1.482,0-.819-.818-1.635-1.64-2.473-2.48-.12.113-.221.2-.317.3q-1.94,1.938-3.881,3.875c-.469.466-.987.454-1.328-.011a.771.771,0,0,1,.118-1.087c.528-.541,1.068-1.072,1.6-1.606q1.538-1.539,3.076-3.076a.85.85,0,0,1,1.424,0Q-992.918,1690.355-991.681,1691.6Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M-984.363,1695.611q0,1.757,0,3.514a.843.843,0,0,1-.8.95.851.851,0,0,1-.835-.929q-.011-3.534,0-7.067a.816.816,0,0,1,.832-.918c.5,0,.8.359.8.935Q-984.361,1693.852-984.363,1695.611Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M-994.052,1696.231c0,.97,0,1.94,0,2.91,0,.6-.319.963-.824.962s-.821-.367-.822-.966q0-2.892,0-5.783c0-.607.307-.974.807-.982.523-.009.838.357.839.986C-994.05,1694.316-994.052,1695.273-994.052,1696.231Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M-989.219,1696.378c0-.893-.005-1.786,0-2.68a.842.842,0,0,1,.81-.938.842.842,0,0,1,.807.942q.008,2.716,0,5.435a.841.841,0,0,1-.81.939.842.842,0,0,1-.807-.942C-989.224,1698.215-989.219,1697.3-989.219,1696.378Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M-992.455,1697.2c0-.642,0-1.285,0-1.927a.8.8,0,0,1,.778-.884.788.788,0,0,1,.849.817q.031,2.021,0,4.043a.819.819,0,0,1-.857.821.833.833,0,0,1-.768-.905C-992.458,1698.514-992.455,1697.859-992.455,1697.2Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M-997.3,1697.817c0,.466.005.931,0,1.4a.822.822,0,0,1-.771.86.8.8,0,0,1-.842-.789q-.04-1.451,0-2.905a.764.764,0,0,1,.844-.77.789.789,0,0,1,.769.849C-997.295,1696.911-997.3,1697.364-997.3,1697.817Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M-1002.142,1698.846c0-.164-.01-.328,0-.491a.812.812,0,0,1,.8-.745.8.8,0,0,1,.787.721,6.54,6.54,0,0,1,0,.98.807.807,0,0,1-.823.764.821.821,0,0,1-.779-.814c-.006-.138,0-.277,0-.415Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M-1002.143,1696.009a.8.8,0,0,1,.813-.807.813.813,0,0,1,.8.828.8.8,0,0,1-.816.8A.8.8,0,0,1-1002.143,1696.009Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M-974.176,1675.972h-.068q-5.556,0-11.113,0a.164.164,0,0,0-.175.109q-.937,1.89-1.884,3.777c-.234.467-.472.933-.709,1.4v.028c.035-.011.07-.02.1-.033l6.49-2.461,7.217-2.735.148-.058Zm-11.37-.953a.207.207,0,0,0,.216.134q5.516-.006,11.03,0h.128a.146.146,0,0,0-.079-.056l-10.838-4.108-3.036-1.147v.027c.025.043.053.085.075.129Q-986.8,1672.506-985.546,1675.019Z",
    fill: "#586973"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup119);
export default __webpack_public_path__ + "static/media/Group 119.4e4f9c91.svg";
export { ForwardRef as ReactComponent };